import { useCountUp } from '../hooks/useCountUp';

const FOUNDED = 2017;

// Cifras reales del negocio, no estimaciones de relleno. Los años se
// calculan desde la fundación para que el dato no envejezca solo.
const STATS = [
    {
        index: '01',
        label: 'Trayectoria',
        value: new Date().getFullYear() - FOUNDED,
        caption: 'Años surtiendo negocios de comida en México',
    },
    {
        index: '02',
        label: 'Clientes',
        prefix: '+',
        value: 200,
        caption: 'Negocios surtidos, de tortillerías a restaurantes',
    },
    {
        index: '03',
        label: 'Volumen',
        prefix: '+',
        value: 1200,
        caption: 'Toneladas de papel grado alimenticio distribuidas',
    },
];

function Stat({ index, label, prefix, value, caption }) {
    const numberRef = useCountUp(value);

    return (
        <div
            className="reveal-on-scroll py-8 md:py-0 border-t first:border-t-0 md:border-t-0 md:border-l md:first:border-l-0 md:px-10 md:first:pl-0 md:last:pr-0"
            style={{ borderColor: 'var(--line)' }}
        >
            <dt className="font-mono text-[10px] uppercase tracking-[0.2em] mb-5" style={{ color: 'var(--ink-soft)' }}>
                <span style={{ color: 'var(--kraft-deep)' }}>{index}</span> / {label}
            </dt>
            <dd>
                <p
                    className="font-heading font-black tracking-tight"
                    style={{ color: 'var(--ink)', fontSize: 'clamp(3.6rem, 8vw, 6.5rem)', lineHeight: 0.82 }}
                >
                    {prefix && <span style={{ color: 'var(--kraft-deep)' }}>{prefix}</span>}
                    {/* La cifra final vive en el HTML; useCountUp solo la
                        sobrescribe mientras anima (ver el hook). */}
                    <span ref={numberRef}>{value}</span>
                </p>
                <p className="text-sm leading-relaxed mt-4 max-w-[24ch]" style={{ color: 'var(--ink-soft)' }}>
                    {caption}
                </p>
            </dd>
        </div>
    );
}

/**
 * Cifras del negocio en tipografía grande: la respuesta visual a la única
 * pregunta que se hace un comprador de mayoreo antes de cotizar — "¿son lo
 * bastante grandes para surtirme?". Números enormes, etiquetas en mono y
 * mucho aire; el dato es el diseño, no un adorno alrededor del dato.
 */
export default function StatsBand() {
    return (
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-20" data-testid="stats-band">
            <p className="eyebrow mb-10 md:mb-14">Carpepel en números</p>

            <dl className="grid grid-cols-1 md:grid-cols-3">
                {STATS.map((s) => (
                    <Stat key={s.index} {...s} />
                ))}
            </dl>
        </section>
    );
}
